import axios from 'axios';
import { setupAxiosInterceptor } from './auth/axiosConfig';
import config from './config';

const agentComputerApi = axios.create({
  baseURL: config.API_BASE_URL + '/cellcog/agent-computer',
});

setupAxiosInterceptor(agentComputerApi);

/**
 * Get Agent Computer status
 * @param {string} chatId - Chat ID
 */
export const getStatus = (chatId) => {
  return agentComputerApi.get(`/${chatId}/status`);
};

/**
 * Create Agent Computer session
 * @param {string} chatId - Chat ID
 * @param {string} tabId - Unique browser tab identifier
 * @param {boolean} startContainer - Whether to start container if not running
 */
export const createSession = (chatId, tabId, startContainer = true) => {
  return agentComputerApi.post(
    `/${chatId}/session`,
    { start_container: startContainer },
    { headers: { 'X-Tab-ID': tabId } }
  );
};

/**
 * End Agent Computer session
 * @param {string} chatId - Chat ID
 * @param {string} sessionId - Session ID to end
 */
export const endSession = (chatId, sessionId) => {
  return agentComputerApi.delete(`/${chatId}/session/${sessionId}`);
};

/**
 * Send session heartbeat
 * @param {string} chatId - Chat ID
 * @param {string} sessionId - Session ID
 * @param {string} cwd - Current working directory
 */
export const heartbeat = (chatId, sessionId, cwd) => {
  return agentComputerApi.post(`/${chatId}/heartbeat`, {
    session_id: sessionId,
    cwd: cwd
  });
};

/**
 * List directory contents
 * @param {string} chatId - Chat ID
 * @param {string} path - Directory path
 * @param {number} limit - Max items to return
 * @param {number} offset - Pagination offset
 */
export const listDirectory = (chatId, path = '/home', limit = 200, offset = 0) => {
  return agentComputerApi.get(`/${chatId}/list`, {
    params: { path, limit, offset }
  });
};

/**
 * Get file URL for preview
 * @param {string} chatId - Chat ID
 * @param {string} path - File path
 * @returns {string} Full URL to file
 */
export const getFileUrl = (chatId, path) => {
  return `${config.API_BASE_URL}/cellcog/agent-computer/${chatId}/file?path=${encodeURIComponent(path)}`;
};

export default agentComputerApi;
